// French for NetworkZone.tsx (BUILD-BRIEF-R5 §6.2, §6.6). Keys already carried by
// `i18n/common.fr.ts` (Save, Cancel, Loading…, Saving…, not collected, proposed, organisation,
// Network, Retract…) are not repeated here.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Payer mix': 'Mix des financeurs',
  'Names': 'Nomme',
  'Named by': 'Nommé par',
  'attributed': 'attribué',
  'held by rule': 'tenu par la règle',
  'estimated': 'estimé',
  'regime, no body named': 'régime, aucun organisme nommé',
  'of revenue': 'des produits',
  'Add link': 'Ajouter un lien',
  'Open in network': 'Ouvrir dans le réseau',
  'Open organisation': 'Ouvrir l’organisation',
  'Clear focus': 'Retirer la cible',
  'Length': 'Longueur',
  'largest first; a bar is a length on a zero baseline, the dotted rest unattributed':
    'le plus grand d’abord ; une barre est une longueur depuis zéro, le reste pointillé non attribué',
  'Σ of the shares above — computed, carries no mark': 'Σ des parts ci-dessus — calculée, sans marque',
  '{r} % unattributed': '{r} % non attribués',
  '{q} of {who}’s {basis} — the dotted rest goes to its other payers':
    '{q} de la {basis} de {who} — le reste pointillé va à ses autres financeurs',
  'known providers account for {n} of the channel’s {m} people in a measure ({when}); the rest is not accounted for':
    'les prestataires connus répondent de {n} des {m} personnes en mesure du canal ({when}) ; du reste, personne ne répond',
  'the channel counts {m} people in a measure ({when}); no provider gives a count yet':
    'le canal compte {m} personnes en mesure ({when}) ; aucun prestataire ne donne encore de nombre',
  'channel volume not collected — the coverage has no denominator until a run reads channel.measure_participants':
    'volume du canal non relevé — la couverture n’a pas de dénominateur tant qu’une recherche ne lit pas channel.measure_participants',
  'Correct figure': 'Corriger le chiffre',
  'Mark ended': 'Marquer comme terminé',
  'In Review': 'En révision',
  'No link is on the record for this organisation. A research run files the payers, mandants and federations its pages name.':
    'Aucun lien n’est enregistré pour cette organisation. Une recherche enregistre les financeurs, mandants et faîtières que ses pages nomment.',
  '{n} of {m} organisations give a count': '{n} organisations sur {m} donnent un nombre',
  'The network could not be read: {error}': 'Le réseau n’a pas pu être lu : {error}',

  'Counterpart': 'Contrepartie',
  'Share': 'Part',
  'Claim': 'Statut',
  'Evidence': 'Preuve',
  'not found': 'non trouvé',
  'Show': 'Afficher',
  'hide evidence': 'masquer la preuve',
  'Role': 'Rôle',
  'Quantity': 'Quantité',
  'Period': 'Période',
  'regime': 'régime',
  'Organisation': 'Organisation',
  'Beneficiaries': 'Bénéficiaires',
  'Year': 'Année',
  'participants': 'participants',
  'places': 'places',

  'Regime': 'Régime',
  'Residual': 'Résidu',
  'Basis': 'Base',
  'None': 'Aucune',
  'Note': 'Note',
  'Ended on': 'Terminé le',
  'Name, ref…': 'Nom, référence…',
  'Pick an organisation from the list.': 'Choisir une organisation dans la liste.',
}, 'NetworkZone');
